import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Loader as BasicLoader } from '@/components/Loader';

export const Wrapper = styled(Flex)<{ $borderless?: boolean }>`
  flex-direction: column;
  align-items: flex-start;

  ${({ $borderless, theme }) => css`
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2)};
    background-color: ${theme.colors.primaryLightAdd2};
    border: ${$borderless ? 'none' : `1px dashed ${theme.colors.primary}`};
  `}

  label {
    align-items: center;
  }
`;

export const Loader = styled(BasicLoader)`
  margin: 0;
`;
